import configurationApi from '@/api/configuration.api'
import store from '@/store/store'
import i18n from '@/i18n'
import { SnackbarStyle } from '@/constants/constants'

export const configurationService = (function () {
  'use strict';

  /**
   * Guarda/actualiza una configuración del usuario
   * @param {*} id id de la configuración
   * @param {*} data configuración
   */
  async function save (id, data, showSnackbar = false) {
    const userId = localStorage.getItem('userId');
    if (userId) {
      const configuration = {
        id,
        data
      };
      configurationApi.save(userId, configuration)
        .then(response => {
          localStorage.setItem('userConfiguration', JSON.stringify(response.configurations));
          if (showSnackbar) {
            store.dispatch('snackbar/showSnackbar', {
              visible: true,
              text: i18n.t('user.configurationSaved'),
              timeout: 6000,
              style: SnackbarStyle.SUCCESS
            })
          }
        })
    }
  }

  /**
   * Obtiene una configuración en particular del usuario
   * @param {*} id identificador de la configuración
   */
  async function get (id) {
    let config;
    try {
      /*
      Primero, se busca en el localstorage, luego en la collection
      */
      const userConfigurationLocal = JSON.parse(localStorage.getItem('userConfiguration'))
        ? JSON.parse(localStorage.getItem('userConfiguration'))
        : [];
      const userId = localStorage.getItem('userId');
      config = userConfigurationLocal.length > 0 ? userConfigurationLocal.find(c => c.id === id) : undefined;
      if (!config) {
        const response = await configurationApi.get(userId, id);
        if (response) {
          userConfigurationLocal.push(response);
          localStorage.setItem('userConfiguration', JSON.stringify(userConfigurationLocal));
          return response;
        } else {
          return undefined;
        }
      } else {
        return config;
      }
    } catch {
      return undefined;
    }
  }

  function getShowCluster (nameComponent) {
    const showClustersValue = localStorage.getItem('showClustersValue' + nameComponent)
    return showClustersValue ? JSON.parse(showClustersValue) : null
  }

  function setShowCluster (showClustersValue, nameComponent) {
    localStorage.setItem('showClustersValue' + nameComponent, JSON.stringify(showClustersValue))
  }

  return {
    save,
    get,
    getShowCluster,
    setShowCluster
  }
})();
